<template>
  <div class="exercise">

    <div class="header">
      <div v-if="exercise.name" class="header__title">{{ exercise.name }}</div>
      <div v-else class="header__title">Добавить упражнение</div>

      <div v-if="editable" class="header__btn btn">
        <save-icon v-if="newItem" @click="saveNewExercise" class="btn__save"/>
        <save-icon v-else @click="save" class="btn__save"/>
        <i v-if="!newItem" @click="remove" class="btn__delete el-icon-delete"></i>
      </div>
      <div v-else @click="changeMode">
        <i class="el-icon-edit header__edit"></i>
      </div>
    </div>

    <div class="title">
      <template v-if="editable">
        <el-input v-model="exercise.name" class="title__input" placeholder="Введите название..."/>
      </template>
      <template v-else>{{ exercise.name }}</template>
    </div>

    <div class="description">
      <template v-if="editable">
        <el-input
            v-model="exercise.description"
            type="textarea"
            :rows="2"
            class="description__textarea"
            placeholder="Введите описание...">
        </el-input>
      </template>
      <template v-else>
        {{ exercise.description }}
      </template>
    </div>

    <div class="times">
      <div class="times__title">Время выполнения</div>

      <template v-if="editable">
        <div class="times__edit">
          <el-input v-model="exercise.exercise_approach" class="times__input" placeholder="Количество подходов"/>
          <el-input v-model="exercise.exercise_time" class="times__input" placeholder="Выбор времени"/>
        </div>

      </template>
      <template v-else>
        <div class="times__description">
          <i class="el-icon-trophy-1"></i>
          {{ exercise.exercise_approach }}
          <i class="times__description_offset el-icon-timer"></i>
          {{ exercise.exercise_time }}
        </div>
      </template>
    </div>

    <div class="gallery">
      <div v-if="editable" class="gallery__header">
        Сопроводите упражнение фото или видео объяснением
      </div>
    </div>

    <attached-files :files="exercise.files" :editable="editable"/>

  </div>
</template>

<script>
import SaveIcon from "@/components/icons/Save"
import AttachedFiles from "@/components/visit/complexExercises/AttachedFiles.vue"

export default {
  name: "ExerciseItem",
  components: {SaveIcon, AttachedFiles},
  props: {
    exercise: {
      type: Object,
      default: () => ({})
    },
    newItem: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      loading: false,
      editable: this.newItem ? true : false
    }
  },
  filters: {
    // approach(value) {
    //   const arr = value.split("-");
    //   const lastNumber = arr[arr.length - 1];
    //
    //   function defineApproach(number) {
    //     number %= 100;
    //     if (number >= 5 && number <= 20) {
    //       return "подходов";
    //     }
    //     number %= 10;
    //     if (number === 1) {
    //       return "подход";
    //     }
    //     if (number >= 2 && number <= 4) {
    //       return "подхода";
    //     }
    //     return "подходов";
    //   }
    //
    //   return `${value} ${defineApproach(lastNumber)}`;
    // }
  },
  methods: {
    changeMode() {
      this.editable = !this.editable
    },
    save() {
      if (!this.newItem) this.editable = false
    },
    remove() {
      this.$emit('remove', this.index)
      if (!this.newItem) this.editable = false
    },
    saveNewExercise() {
      this.$emit('save', this.exercise)
    }
  }
}

</script>
<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__title {
    margin-top: 12px;

    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: #8E8E93;

  }

  &__edit {
    font-size: 13px;
    line-height: 13px;

    color: #989ca6;
    cursor: pointer;

    &:hover {
      opacity: 0.5
    }
  }

  &__btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

}

.btn {
  &__save, &__delete {
    color: #111;
    cursor: pointer;
    font-size: 13px;

    &:hover {
      opacity: 0.5
    }
  }

  &__delete {
    margin-left: 8px;
  }

}

.exercise {
  //max-width: 380px;
  min-width: 260px;
  min-height: 278px;
  padding: 10px 16px;

  background-color: #ffffff;
  border-radius: 4px;
}

.title {
  margin-top: 12px;


  font-weight: 600;
  font-size: 17px;
  line-height: 22px;

  color: #111;

  &__input {
    /deep/ input {
      padding: 18px 15px !important;
      font-style: normal;
      font-weight: 600;
      font-size: 17px;
      line-height: 29px;
    }
  }
}

.description {
  margin-top: 4px;

  font-size: 13px;
  line-height: 16px;

  color: #111;

  &__textarea {
    /deep/ textarea {


      color: #111;
    }
  }


}


.times {
  margin-top: 12px;

  &__title {
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;

    color: #111;
  }

  &__description {
    margin-top: 5px;

    font-size: 12px;
    line-height: 13px;
    color: #078065;

    &_offset {
      margin-left: 5px;
    }
  }

  &__edit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px -5px 0 -5px;
  }

  &__input {
    margin: 0 5px;
  }

}

.gallery {
  margin-top: 12px;

  &__header {
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.005em;
    color: #111111;
  }
}
</style>
